module.exports = __webpack_public_path__ + "static/media/logo_hyponav_premium_white.5472ffe0.svg";